import { GovernanceScore } from './GovernanceScore';
import { GovernanceScoreHistory } from './GovernanceScoreHistory';
import GovernanceTimeline from './GovernanceTimeline';
import { History } from 'lucide-react';

const AuditTrailView = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
          <History className="w-5 h-5 text-primary" />
        </div>
        <div>
          <h1 className="text-2xl font-semibold text-foreground">Audit Trail</h1>
          <p className="text-sm text-muted-foreground">Governance score, history, and the full evidence timeline.</p>
        </div>
      </div>

      <GovernanceScore />
      <GovernanceScoreHistory />
      <GovernanceTimeline />
    </div>
  );
};

export default AuditTrailView;
